import { getIsFileManagerUrl } from 'FileManagerCore/utils/file';
export default getIsFileManagerUrl;